import { FC, MouseEventHandler, ReactNode } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';

export type RowActionItem = {
  id: string;
  label: string;
  icon: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  loading?: boolean;
  /** Destructive styling (delete, etc.) */
  destructive?: boolean;
};

type RowActionsProps = {
  actions: RowActionItem[];
  size?: 'small' | 'medium';
};

/** Explicit labeled icon actions; replaces three-dot overflow menus */
export const RowActions: FC<RowActionsProps> = ({
  actions,
  size = 'small',
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      spacing={0.25}
      onClick={(e) => e.stopPropagation()}
    >
      {actions.map((action) => (
        <Tooltip key={action.id} title={action.label} enterDelay={400} enterNextDelay={0}>
          <span>
            <IconButton
              size={size}
              aria-label={action.label}
              disabled={action.disabled || action.loading}
              color={action.destructive ? 'error' : 'default'}
              onClick={action.onClick}
              sx={{
                opacity: action.loading ? 0.5 : 1,
              }}
            >
              {action.icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Stack>
  );
};
